import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../actions/navigationActions';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { DASHBOARD, CLAIMS, CLAIM_HISTORY_V2 } from '../../routes/routes';
import './ClaimInMeantime-and-EndInMeantime.css';

class ClaimComplete extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    handleRedirect() {
        this.props.redirectTo(CLAIM_HISTORY_V2);
    }

    //componentDidMount() {
    //    this.props.dispatchHideProfile();
    //}

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: CLAIMS, description: "Claims" }]

        return (
            <div id="ClaimComplete">
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Claim complete" />
                <div className="submit-a-claim-history-block mb-5">
                    <div className="container pt-3 pb-3">
                        <div className="border-bottom mb-3">
                            <p className="claim-submitted mt-3"><img src="./Images/Claims/icons-checkmark-progress-complete-24-px@2x.png" alt="complete" className="pr-3" />Claim submitted</p>
                            <p className="claim-submited-sub mb-2">Your claim info has been sent to our team</p>
                        </div>

                        <div className="border-bottom mt-3">
                            <p className="thanks"><b>Thanks!</b></p>
                            <p className="claim-submited-sub mb-3">Keep an eye on you claim progress by clicking here:</p>
                            <button className="claim-btn-mobile btn btn-outline-red mt-3 mb-3" onClick={this.handleRedirect}>View claim status</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        //dispatchHideProfile: () => dispatch(hideMobileProfile()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimComplete);